module.exports = __webpack_public_path__ + "img/2b423e25c4674b7a73d42ca8c9e3fe74.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_banner_icon2.png
// module id = 907
// module chunks = 5